import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('authentication', [
      'getProjectId',
      'getProjectName',
      'getUserId',
      'getFirstName',
      'getUserGroup',
      'getIsSupervisor',
      'getIsAdministrator',
      'getStartDateOfProject',
      'getCurrentWeek'
    ])
  }
}
